import React, { ReactNode, FunctionComponent } from 'react';

type PageContentProps = {
    children: ReactNode;
};

const PageContent: FunctionComponent<PageContentProps> = ({ children }) => (
    <main className="page-content">{children}</main>
);

export default PageContent;
